export enum IWorkingSessionsAnalyticsActivityV2Enum {
  SessionId = 'WorkingSessionsAnalyticsActivityV2.session_id',
  LocalSessionStart = 'WorkingSessionsAnalyticsActivityV2.local_session_start',
  LocalSessionStartDate = 'WorkingSessionsAnalyticsActivityV2.local_session_start_date',
  LocalSessionEnd = 'WorkingSessionsAnalyticsActivityV2.local_session_end',
  FocusPercentage = 'WorkingSessionsAnalyticsActivityV2.focusPercentage',
  DigitalIntensity = 'WorkingSessionsAnalyticsActivityV2.digitalIntensity',
  SessionCallDuration = 'WorkingSessionsAnalyticsActivityV2.session_call_duration',
  SessionCallCount = 'WorkingSessionsAnalyticsActivityV2.session_call_count',
  TotalActivityDuration = 'WorkingSessionsAnalyticsActivityV2.totalActivityDuration',
  TotalFocusDuration = 'WorkingSessionsAnalyticsActivityV2.totalFocusDuration',
  TotalSessionCallDuration = 'WorkingSessionsAnalyticsActivityV2.totalSessionCallDuration',
  UserId = 'WorkingSessionsAnalyticsActivityV2.userid',
  CumulativeDailyAverageScreentime = 'WorkingSessionsAnalyticsActivityV2.cumulativeDailyAverageScreentime',
  CumulativeDailyAverageWorkingHours = 'WorkingSessionsAnalyticsActivityV2.cumulativeDailyAverageWorkingHours',
  CumulativeWeeklyAverageScreentime = 'WorkingSessionsAnalyticsActivityV2.cumulativeDailyAverageScreentime',
  CumulativeWeeklyAverageWorkingHours = 'WorkingSessionsAnalyticsActivityV2.cumulativeDailyAverageWorkingHours',
  WeekCount = 'WorkingSessionsAnalyticsActivityV2.weekCount',
  DayCount = 'WorkingSessionsAnalyticsActivityV2.dayCount',
  CallWeekCount = 'WorkingSessionsAnalyticsActivityV2.callWeekCount',
  CallDayCount = 'WorkingSessionsAnalyticsActivityV2.callDayCount',
  WeekDayIndex = 'WorkingSessionsAnalyticsActivityV2.weekday_index',
  TotalDuration = 'WorkingSessionsAnalyticsActivityV2.totalDuration',
  ContextSwitches = 'WorkingSessionsAnalyticsActivityV2.context_switches',
  FocusScore = 'WorkingSessionsAnalyticsActivityV2.focus_score_v2',
  SessionDuration = 'WorkingSessionsAnalyticsActivityV2.session_duration',
  MeetingFocusScore = 'WorkingSessionsAnalyticsActivityV2.meeting_focus_score',
  LocalSessionStartWeek = 'WorkingSessionsAnalyticsActivityV2.local_session_start_week',
  SessionFocusDuration = 'WorkingSessionsAnalyticsActivityV2.session_focus_duration',
  SessionActivityDuration = 'WorkingSessionsAnalyticsActivityV2.session_activity_duration',
  ActivityCount = 'WorkingSessionsAnalyticsActivityV2.activity_count',
}
